import React from "react";
import { View, Text, StyleSheet } from "react-native";

import IntegrationIcons from "../../../common/icons/integrations/index";
import fontStyles from "../../../../fonts";
import AppTheme from "../../../AppTheme";
import appStyles from "../../../../appStyles";
import Header from "../../../common/header/index";

export default function HealthEmptyWebScreen({
  goBack = () => {},
  sendEmail = () => {},
}) {
  return (
    <View style={[appStyles.container, { backgroundColor: "#FFF" }]}>
      <Header title="Apple Health" goBack={goBack} />
      <Text style={[fontStyles.h3, styles.text, { marginTop: "30%" }]}>
        Download Mana for iPhone to integrate with Apple Health
      </Text>

      <View style={styles.imageContainer}>
        <IntegrationIcons.HealthEmptyIcon />
      </View>

      <Text style={[fontStyles.h3, styles.text]}>
        We’ve sent you an email with instructions. Check your spam folder if you
        haven’t received it, or
      </Text>
      <Text
        style={[fontStyles.h3, styles.text, { color: AppTheme.DEFAULT_COLOR }]}
        onPress={sendEmail}
      >
        tap here to send again.
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  imageContainer: {
    alignItems: "center",
    marginTop: 24,
    marginBottom: 24,
  },
  text: {
    paddingHorizontal: "14%",
    textAlign: "center",
  },
});
